import { Observable, of } from 'rxjs';

import { UserService } from '../user/user.service';
import { BaseProductService } from './-base-product.service';
import { BaseProductStateModel } from './base-product-state.models';

export class BaseProductInterviewData {

    constructor(
        protected productService: BaseProductService<BaseProductStateModel>,
        protected userService: UserService
        ) {
    }

    getNotQualifiedItems(): Observable<string[]> {
        return of([]);
    }

    generateNotInterestedItems(): Observable<string[]> {
        return of([]);
    }
}
